import baseGoApi from "@/api/baseGoApi";
import { Package } from "@/types/Package";

const PACKAGE_ENDPOINT = "/packages";

export const fetchPackages = async (): Promise<Package[]> => {
    try {
        const response = await baseGoApi.get(PACKAGE_ENDPOINT);
        return response.data as Package[];
    } catch (error: any) {
        console.error("Error fetching packages:", error);
        throw new Error("Failed to fetch packages.");
    }
};

export const fetchPackageById = async (id: number): Promise<Package> => {
    try {
        const response = await baseGoApi.get(`${PACKAGE_ENDPOINT}/${id}`);
        return response.data as Package;
    } catch (error: any) {
        console.error(`Error fetching package with ID ${id}:`, error);
        throw new Error(`Failed to fetch package with ID ${id}.`);
    }
};

export const createPackage = async (packageData: Partial<Package>): Promise<Package> => {
    try {
        const response = await baseGoApi.post(PACKAGE_ENDPOINT + '/', packageData);
        return response.data as Package;
    } catch (error: any) {
        console.error("Error creating package:", error);
        throw new Error("Failed to create package.");
    }
};

export const updatePackage = async (id: number, packageData: Partial<Package>): Promise<Package> => {
    try {
        const response = await baseGoApi.put(`${PACKAGE_ENDPOINT}/${id}`, packageData);
        return response.data as Package;
    } catch (error: any) {
        console.error(`Error updating package with ID ${id}:`, error);
        throw new Error(`Failed to update package with ID ${id}.`);
    }
};

export const deletePackage = async (id: number): Promise<void> => {
    try {
        await baseGoApi.delete(`${PACKAGE_ENDPOINT}/${id}`);
    } catch (error: any) {
        console.error(`Error deleting package with ID ${id}:`, error);
        throw new Error(`Failed to delete package with ID ${id}.`);
    }
};

export const sortPackages = async (sortedIDs: number[]): Promise<void> => {
    try {
        await baseGoApi.put("/packages/sort-order", { order: sortedIDs });
    } catch (error: any) {
        console.error("Error saving sorted package order:", error);
        throw new Error("Failed to save package order.");
    }
}; 